import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth'
import lead from './lead'
import leads from './leads'
import notes from './notes'
import snackbar from './snackbar'
import records from './records'
import agents from './agents'
import baseData from './base_data'
import rawLeads from './rawLeads'
import emails from './emails'
import missedCalls from './missedCalls'
import twilio from './twilio'
import guide from './guide'
import settings from './settings'
import states from './states'
import autodialer from './autodialer'
import statuses from './statuses'
import sources from './sources'
import filters from "./filters";
import coldCall from "./coldCall";
import messages from "./messages";
import voicemails from "./voicemails";
import conference from "./conference";
import notifications from "@/store/notifications";
import templates from "@/store/templates";
import followups from "@/store/followups";
import statistic from "@/store/statistic";
import deals from "./deals";

import plates from "@/store/plates";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
  },
  mutations: {
    "LOGOUT"() {
    }
  },
  actions: {
    "SOCKET_BANNED"({ commit }) {
      commit("LOGOUT", null);
    }
  },
  modules: {
    auth,
    autodialer,
    lead,
    leads,
    notes,
    snackbar,
    records,
    rawLeads,
    agents,
    baseData,
    emails,
    missedCalls,
    twilio,
    guide,
    settings,
    states,
    statuses,
    sources,
    filters,
    deals,
    coldCall,
    messages,
    voicemails,
    notifications,
    templates,
    conference,
    followups,
    statistic,
    plates,
  }
});
